import Phaser from 'phaser'
import Preloader from './scenes/Preloader'
import { PlayGame } from './scenes/PlayGame'
import GlobalScene from './scenes/GlobalScene'
import UI from './scenes/UI'
import { RockyRoller } from './scenes/RockyRoller'
import GameManager from './scenes/GameManager'

const config: Phaser.Types.Core.GameConfig = {
	type: Phaser.AUTO,
	width:1080,
	height: 1920,
	physics: {
		default: 'arcade',
		arcade: {
			gravity: { y: 1000 },
			debug:true
		}
	},
	scale:{
		mode:Phaser.Scale.FIT,
		autoCenter:Phaser.Scale.CENTER_BOTH,
		width:1920,
		height:1080
	}, 
	
	// scene: [Preloader,PlayGame,UI]
	// scene: [GlobalScene,Preloader,PlayGame,UI]
	scene: [Preloader,UI,GameManager]
}

export default new Phaser.Game(config)
